import React from 'react';
import './side_menu.css';
import { useTranslation } from 'react-i18next';

const SideMenu = ({ isOpen, onClose, selectedPage, setSelectedPage }) => {
    const { t, i18n } = useTranslation('header');

    const setAndClosePage = (pageNum) => {
        setSelectedPage(pageNum);
        onClose();
    }

    return (
        <div className={`side-menu ${isOpen ? 'side-menu--open' : ''}`}>
            <button className="side-menu__close-btn" onClick={onClose}>
                &times; {/* Close icon */}
            </button>

            <nav className="side-menu__nav">
                <a href="#home" className="side-menu__link" onClick={() => setAndClosePage(1)}>{t('inicio')}</a>
                <a href="#about" className="side-menu__link" onClick={() => setAndClosePage(2)}>{t('sobre_nosotros')}</a>
                <a href="#services" className="side-menu__link" onClick={() => setAndClosePage(3)}>{t('centro_quiropractiro')}</a>
                <a href="#contact" className="side-menu__link" onClick={() => setAndClosePage(4)}>{t('dosier_cientifico')}</a>
            </nav>
        </div>
    );
};

export default SideMenu;
